export default __webpack_public_path__ + "static/media/notification.4678e548.svg";